// extracted by mini-css-extract-plugin
export default {"container":"PoweredBy_container__0XenG","link":"PoweredBy_link__apPUZ","logo":"PoweredBy_logo__m462d"};